import { Observable } from '../tools/observable';
export var TrackingConsent = {
  GRANTED: 'granted',
  NOT_GRANTED: 'not-granted'
};
export function createTrackingConsentState(currentConsent) {
  var observable = new Observable();
  return {
    tryToInit: function tryToInit(trackingConsent) {
      if (!currentConsent) {
        currentConsent = trackingConsent;
      }
    },
    update: function update(trackingConsent) {
      currentConsent = trackingConsent;
      observable.notify();
    },
    isGranted: function isGranted() {
      return currentConsent === TrackingConsent.GRANTED;
    },
    observable: observable
  };
}